import type { PlayerSessionView } from "@secret-cabinet/contracts";

const SESSION_PREFIX = "secret-cabinet:player:";

export function loadPlayerSession(code: string): PlayerSessionView | null {
  try {
    const raw = window.localStorage.getItem(`${SESSION_PREFIX}${code}`);
    if (!raw) {
      return null;
    }
    const value = JSON.parse(raw) as Partial<PlayerSessionView>;
    return typeof value.id === "string" && typeof value.token === "string"
      ? { id: value.id, token: value.token }
      : null;
  } catch {
    return null;
  }
}

export function savePlayerSession(code: string, session: PlayerSessionView): void {
  window.localStorage.setItem(`${SESSION_PREFIX}${code}`, JSON.stringify(session));
}

export function clearPlayerSession(code: string): void {
  window.localStorage.removeItem(`${SESSION_PREFIX}${code}`);
}
